(function() {
    'use strict';
    
    const $body = document.body;
    
    const askAnExpert = {
        initAskAnExpert: function () {
            document.addEventListener('click', (event) => {
                const openBtn = event.target.closest('[data-open-ask-an-expert]');
                if (!openBtn) return;
                
                event.preventDefault();
                event.stopPropagation();

                var askAnExpert = document.querySelector('[data-ask-an-expert-popup]');
                if (!askAnExpert) return;

                var modalContent = askAnExpert.querySelector('.halo-popup-content');
                if (!modalContent) return;

                var url;

                if ($body.classList.contains('template-product')) {
                    const productView = document.querySelector('.productView');
                    var handle = productView ? productView.dataset.productHandle : null;
                    if (handle) {
                    url = window.routes.root + '/products/' + handle + '?view=ajax_ask_an_expert';
                    }
                } else if ($body.classList.contains('quick-view-show')) {
                    const quickView = document.querySelector('.halo-quickView');
                    var handle = quickView ? quickView.dataset.productQuickviewHandle : null;
                    if (handle) {
                        url = window.routes.root + '/products/' + handle + '?view=ajax_ask_an_expert';
                    }
                } else {
                    url = window.routes.root + '/search?view=ajax_ask_an_expert';
                }

                if (!url) return;

                // Clear content before loading
                modalContent.innerHTML = '';

                fetch(url)
                    .then(response => {
                        if (!response.ok) {
                            return response.json().then(err => {
                                throw new Error(err.description || 'Error loading form');
                            });
                        }
                        return response.text();
                    })
                    .then(data => {
                        modalContent.innerHTML = data;
                        $body.classList.add('ask-an-expert-show');
                    })
                    .catch(error => {
                        alert(error.message || 'Error loading form');
                });
            });

            document.addEventListener('click', (event) => {
                const closeBtn = event.target.closest('[data-close-ask-an-expert]');
                if (closeBtn) {
                event.preventDefault();
                event.stopPropagation();
                    $body.classList.remove('ask-an-expert-show');
                    if ($body.classList.contains('recently-popup-mb-show')) {
                        $body.classList.remove('recently-popup-mb-show');
                    }
                }
            });

            document.addEventListener('click', (event) => {
                if ($body.classList.contains('ask-an-expert-show')) {
                    const openBtn = event.target.closest('[data-open-ask-an-expert]');
                    const popup = event.target.closest('#halo-ask-an-expert-popup');
                    if (!openBtn && !popup) {
                        $body.classList.remove('ask-an-expert-show');
                    }
                }
            });
        }
    };
    
    // Attach to window.halo
    if (!window.halo) {
        window.halo = {};
    }
    
    // Attach all ask an expert functions to halo
    Object.assign(window.halo, askAnExpert);
    
    // Auto-initialize
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            askAnExpert.initAskAnExpert();
        });
    } else {
        askAnExpert.initAskAnExpert();
    }
})();









